import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import ReactDatePicker from 'react-datepicker';
import moment from 'moment-timezone';
import SalesController, { SalesListType, LogListType } from '../../controller/SalesController';
import 'react-datepicker/dist/react-datepicker.css';
import ko from 'date-fns/locale/ko';
import MenuDetailModal from '../../components/modal/menuDetailModal';
import ReadyAdminForceModal from '../../components/modal/readyAdminForceModal';
import OrderController from '../../controller/OrderController';
import CustomTable from '../../components/Table';
import { useNavigate } from 'react-router-dom';
import { managers } from '../../controller/ManagerController';
import DetectorController, { DevicePathLogType } from '../../controller/DetectorController';
import OrderLogModal from '../../components/modal/OrderLogModal';

interface tabType {
  id: number;
  tab: string;
}

type TotalType = {
  totalOrderCount: number;
  successOrderCount: number;
  cancelOrderCount: number;
  totalCancelAmountIncSum: number;
  totalAmountIncSum: number;
  totalAmountOrgSum: number;
  companyDiscountSum: number;
  storeDiscountSum: number;
  deliveryTipSum: number;
  roomTipSum: number;
};
const dateTabContent = [
  {
    id: 0,
    tab: '오늘',
  },
  {
    id: 1,
    tab: '어제',
  },
  {
    id: 2,
    tab: '최근 7일',
  },
  {
    id: 3,
    tab: '최근 30일',
  },
  {
    id: 4,
    tab: '기간 선택',
  },
];
const useTabs = (initialTabs: tabType[]) => {
  const [contentIndex, setContentIndex] = useState<number>(0);

  const activateTab = (index: number) => {
    setContentIndex(index);
  };
  return {
    contentItem: initialTabs[contentIndex],
    contentChange: activateTab,
    activeIndex: contentIndex,
  };
};

const KnockSales = () => {
  const navigate = useNavigate();
  const nowDate = new Date();
  nowDate.setHours(0, 0, 0, 0);
  const currentDayOfWeek = nowDate.getDay();
  // 어제
  const yesterdayDate = new Date(nowDate);
  yesterdayDate.setDate(nowDate.getDate() - 1);

  // 최근 7일
  const weekStartDate = new Date(nowDate);
  weekStartDate.setDate(nowDate.getDate() - 6);
  const weekEndDate = new Date(nowDate);

  // 이번달
  // const monthStartDate = new Date(nowDate.getFullYear(), nowDate.getMonth(), 1);
  // const monthEndDate = new Date(nowDate.getFullYear(), nowDate.getMonth() + 1, 0);
  const monthStartDate = new Date(nowDate);
  monthStartDate.setDate(nowDate.getDate() - 30);
  const monthEndDate = new Date(nowDate);

  const [visibleReadyOrder, setVisibleReadyOrder] = useState<boolean>(false);
  const [visibleOrder, setVisibleOrder] = useState<boolean>(false);
  const [salesList, setSalesList] = useState<any>([]);
  const [startDate, setStartDate] = useState<Date | null>(nowDate);
  const [endDate, setEndDate] = useState<Date | null>(nowDate);
  const [orderId, setOrderId] = useState<string>('');
  const [detailOrderId, setDetailOrderId] = useState<string>('');
  const [storeName, setStoreName] = useState<string>('');
  const [orderDetail, setOrderDetail] = useState<any>();
  const [storeDetailData, setStoreDetailData] = useState<SalesListType | null>(null);

  const [hotelVisible, setHotelVisible] = useState<boolean>(false);
  const [storeVisible, setStoreVisible] = useState<boolean>(false);
  const [pathLogVisible, setPathLogVisible] = useState<boolean>(false);

  const [orderLogData, setOrderLogData] = useState<DevicePathLogType[]>([]);
  const [visibleOrderLog, setVisibleOrderLog] = useState<boolean>(false);

  const [total, setTotal] = useState<TotalType>({
    totalOrderCount: 0,
    successOrderCount: 0,
    cancelOrderCount: 0,
    totalCancelAmountIncSum: 0,
    totalAmountIncSum: 0,
    totalAmountOrgSum: 0,
    companyDiscountSum: 0,
    storeDiscountSum: 0,
    deliveryTipSum: 0,
    roomTipSum: 0,
  });
  const [hotelTotal, setHotelTotal] = useState<{ hotel_name: string; total: TotalType }[]>([]);
  const [storeTotal, setStoreTotal] = useState<{ hotel_name: string; total: TotalType }[]>([]);
  const [searchStoreName, setSearchStoreName] = useState<string>('');
  const { contentItem: dateContentItem, contentChange: dateContentChange } =
    useTabs(dateTabContent);
  const tabClick = (index: number) => {
    dateContentChange(index);
    if (index === 0) {
      setStartDate(nowDate);
      setEndDate(nowDate);
    } else if (index === 1) {
      setStartDate(yesterdayDate);
      setEndDate(yesterdayDate);
    } else if (index === 2) {
      setStartDate(weekStartDate);
      setEndDate(weekEndDate);
    } else if (index === 3) {
      setStartDate(monthStartDate);
      setEndDate(monthEndDate);
    }
  };
  const handleDateChange = (dates: [Date | null, Date | null]) => {
    setStartDate(dates[0]);
    setEndDate(dates[1]);
  };

  const excelHotelHeader = [
    '호텔이름(결제금액순)',
    '주문완료',
    '배달완료',
    '취소',
    '결제금액',
    '주문금액',
    '총 할인금액',
    'IVID 부담',
    '매장/호텔 부담',
    '배달팁',
    '객실관리팁',
    '취소금액',
  ];

  const excelStoreHeader = [
    '매장이름(결제금액순)',
    '주문완료',
    '배달완료',
    '취소',
    '결제금액',
    '주문금액',
    '총 할인금액',
    'IVID 부담',
    '매장/호텔 부담',
    '배달팁',
    '객실관리팁',
    '취소금액',
  ];

  // 매장명검색
  const handleSearchStoreName = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchStoreName(event.target.value);
  };

  const [filteredItems, setFilteredItems] = useState<SalesListType[]>([]);

  const renderHotelTableItem = () => {
    return (
      <>
        {hotelTotal.map((data, dataIndex: number) => (
          <tr className="webTableWrap">
            <td>{data.hotel_name}</td>
            <td>{data.total.totalOrderCount}건</td>
            <td>{data.total.successOrderCount}건</td>
            <td>{data.total.cancelOrderCount}건</td>
            <td>{data.total.totalAmountIncSum.toLocaleString()}원</td>
            <td>{data.total.totalAmountOrgSum.toLocaleString()}원</td>
            <td>
              {(data.total.companyDiscountSum + data.total.storeDiscountSum).toLocaleString()}원
            </td>
            <td>{data.total.companyDiscountSum.toLocaleString()}원</td>
            <td>{data.total.storeDiscountSum.toLocaleString()}원</td>
            <td>{data.total.deliveryTipSum.toLocaleString()}원</td>
            <td>{data.total.roomTipSum.toLocaleString()}원</td>
            <td>{data.total.totalCancelAmountIncSum.toLocaleString()}원</td>
          </tr>
        ))}
        {hotelTotal.length > 0 ? (
          <tr className="webTableWrap" style={{ background: 'yellow' }}>
            <td>합계</td>
            <td>{total.totalOrderCount}건</td>
            <td>{total.successOrderCount}건</td>
            <td>{total.cancelOrderCount}건</td>
            <td>{total.totalAmountIncSum.toLocaleString()}원</td>
            <td>{total.totalAmountOrgSum.toLocaleString()}원</td>
            <td>{(total.companyDiscountSum + total.storeDiscountSum).toLocaleString()}원</td>
            <td>{total.companyDiscountSum.toLocaleString()}원</td>
            <td>{total.storeDiscountSum.toLocaleString()}원</td>
            <td>{total.deliveryTipSum.toLocaleString()}원</td>
            <td>{total.roomTipSum.toLocaleString()}원</td>
            <td>{total.totalCancelAmountIncSum.toLocaleString()}원</td>
          </tr>
        ) : (
          <></>
        )}
      </>
    );
  };

  const renderStoreTableItem = () => {
    return (
      <>
        {storeTotal.map((data, dataIndex: number) => (
          <tr className="webTableWrap">
            <td>{data.hotel_name}</td>
            <td>{data.total.totalOrderCount}건</td>
            <td>{data.total.successOrderCount}건</td>
            <td>{data.total.cancelOrderCount}건</td>
            <td>{data.total.totalAmountIncSum.toLocaleString()}원</td>
            <td>{data.total.totalAmountOrgSum.toLocaleString()}원</td>
            <td>
              {(data.total.companyDiscountSum + data.total.storeDiscountSum).toLocaleString()}원
            </td>
            <td>{data.total.companyDiscountSum.toLocaleString()}원</td>
            <td>{data.total.storeDiscountSum.toLocaleString()}원</td>
            <td>{data.total.deliveryTipSum.toLocaleString()}원</td>
            <td>{data.total.roomTipSum.toLocaleString()}원</td>
            <td>{data.total.totalCancelAmountIncSum.toLocaleString()}원</td>
          </tr>
        ))}
        {hotelTotal.length > 0 ? (
          <tr className="webTableWrap" style={{ background: 'yellow' }}>
            <td>합계</td>
            <td>{total.totalOrderCount}건</td>
            <td>{total.successOrderCount}건</td>
            <td>{total.cancelOrderCount}건</td>
            <td>{total.totalAmountIncSum.toLocaleString()}원</td>
            <td>{total.totalAmountOrgSum.toLocaleString()}원</td>
            <td>{(total.companyDiscountSum + total.storeDiscountSum).toLocaleString()}원</td>
            <td>{total.companyDiscountSum.toLocaleString()}원</td>
            <td>{total.storeDiscountSum.toLocaleString()}원</td>
            <td>{total.deliveryTipSum.toLocaleString()}원</td>
            <td>{total.roomTipSum.toLocaleString()}원</td>
            <td>{total.totalCancelAmountIncSum.toLocaleString()}원</td>
          </tr>
        ) : (
          <></>
        )}
      </>
    );
  };

  // 주문 상태
  const getStatusComment = (status: number) => {
    if (status === 0) return '주문대기';
    else if (status === 1) return '준비중';
    else if (status === 2) return '조리완료';
    else if (status === 3) return '서빙완료';
    else if (status === 4) return '주문취소';
    else if (status === 5) return '주문완료';
    else if (status === 6) return '배달시작';
    else if (status === 7) return '배달완료';
  };
  const getClickStatus = (params: string) => {
    if (params === 'click') return '클릭';
    else if (params === 'cart') return '장바구니 변동';
  };
  // 국적
  const getStatusCountry = (status: number) => {
    if (status === 0)
      return <img src={`${process.env.PUBLIC_URL}/svg/flag_korea.svg`} alt="한국" />;
    else if (status === 1)
      return <img src={`${process.env.PUBLIC_URL}/svg/flag_usa.svg`} alt="미국" />;
    else if (status === 2)
      return <img src={`${process.env.PUBLIC_URL}/svg/flag_china.svg`} alt="중국" />;
    else if (status === 3)
      return <img src={`${process.env.PUBLIC_URL}/svg/flag_japan.svg`} alt="일본" />;
    else if (status === 4)
      return <img src={`${process.env.PUBLIC_URL}/svg/flag_thailand.svg`} alt="태국" />;
    else if (status === 5)
      return <img src={`${process.env.PUBLIC_URL}/svg/flag_spain.svg`} alt="스페인" />;
    else if (status === 6)
      return <img src={`${process.env.PUBLIC_URL}/svg/flag_france.svg`} alt="프랑스" />;
    else if (status === 7)
      return <img src={`${process.env.PUBLIC_URL}/svg/flag_russia.svg`} alt="러시아" />;
    else if (status === 8)
      return <img src={`${process.env.PUBLIC_URL}/svg/flag_germany.svg`} alt="독일" />;
  };

  const managerAuthorityButton = (data: any, type: string) => {
    let adminName: string | null = prompt(`관리자명을 입력해 주세요. 변경시 되돌릴 수 없습니다.`);
    if (adminName !== null && !managers?.includes(adminName)) {
      alert('등록되지않은 관리자입니다. 다시 시도해주세요.');
    } else if (adminName !== null && managers?.includes(adminName)) {
      if (type === 'delivery') {
        completeOrderForce(adminName, data);
      } else if (type === 'refund') {
        cancelAdminForce(adminName, data);
      }
    }
    return adminName;
  };
  const managerReadyOrder = (data: any) => {
    setStoreDetailData(data);

    if (data) {
      setVisibleReadyOrder(true);
    }
  };
  const successManagerReadyOrder = (deliveryTime: string, adminName: string) => {
    if (deliveryTime === '') {
      alert('배달 도착 시간을 입력해주세요.');
    } else if (adminName !== null && !managers?.includes(adminName)) {
      alert('관리자명이 일치하지 않습니다.');
    } else {
      setVisibleReadyOrder(false);
      readyAdminForce(deliveryTime, adminName);
    }
  };

  // POS log
  const getOrderPath = async (order_id: string, store_name: string) => {
    try {
      setStoreName(store_name);
      setDetailOrderId(order_id);

      const oData = {
        order_id,
      };

      const response = await DetectorController.getOrderPathlog(oData);

      if (response && response.data) {
        setVisibleOrderLog(true);
        setOrderLogData(response.data.data);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  // 수동 주문 접수
  const readyAdminForce = async (deliveryTime: string, adminName: string) => {
    try {
      const oData = {
        order_id: storeDetailData?.order_id,
        delivery_estimated_time: Number(deliveryTime),
        admin: adminName,
      };

      const response = await OrderController.readyAdminForce(oData);
      if (response.data.ok) {
        getSettlement();
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  // 수동 배달 완료 처리
  const completeOrderForce = async (adminName: string, data: SalesListType) => {
    try {
      const oData = {
        order_id: data.order_id,
        store_name: `${data.store_name}:${moment(data.ordered_at).format('YYYY-MM-DD HH:mm:ss')}`,
        origin_status: `${getStatusComment(data.order_status)}`,
        admin_name: adminName,
      };

      const response = await OrderController.completeOrderForce(oData);
      if (response.data.ok) {
        getSettlement();
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  // 강제 주문 취소
  const cancelAdminForce = async (adminName: string, data: SalesListType) => {
    try {
      const oData = {
        order_id: data.order_id,
        order_seq: data.order_seq,
        admin_name: adminName,
      };

      const response = await OrderController.cancelAdminForce(oData);
      if (response.data.ok) {
        getSettlement();
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  // 판매현황 API
  const getSettlement = async () => {
    try {
      const oData = {
        start_date: moment(startDate).format('YYYY-MM-DD'),
        end_date: moment(endDate).format('YYYY-MM-DD'),
      };

      const response = await SalesController.getSalesList(oData);

      if (response.data.ok) {
        setSalesList(response.data.data.list);
        setOrderId(response.data.data.list.map((data: any) => data.order_id));
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  const getOrderMenu = async (order_id: string, store_name: string) => {
    try {
      const oData = {
        order_id: order_id,
      };
      setStoreName(store_name);
      setDetailOrderId(order_id);
      const response = await SalesController.getOrderByOrderId(oData);

      if (response.data.ok) {
        setVisibleOrder(true);
        setOrderDetail(response.data.data.order.child[0]);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  // 주문 리스트
  const RenderHistoryList = () => {
    let tempfilteredItems: SalesListType[] = [];
    if (pathLogVisible) {
      tempfilteredItems = filteredItems;
    } else {
      tempfilteredItems = filteredItems.filter((v) => v.data_type === 'order');
    }

    return (
      <div className="historyList">
        {tempfilteredItems.map((data: SalesListType | LogListType, index: number) => {
          const currentTime = moment();
          return (
            <div key={index}>
              {data.data_type === 'order' ? (
                <div className="historyItem">
                  <div className="row">
                    <div className={`itemBadge status ${data.order_status === 4 && 'cancel'}`}>
                      {getStatusComment(data.order_status)}
                    </div>
                    <div className="itemBadge">
                      <h5 className="title">호텔명: </h5>
                      {data.hotel_name}
                    </div>
                    <div className="itemBadge">
                      <h5 className="title">객실: </h5>
                      {data.delivery_address_detail}
                    </div>
                    <div className="itemBadge">
                      <h5 className="title">주문시간: </h5>
                      {moment(data.ordered_at).format('yyyy.MM.DD HH:mm:ss')}
                    </div>
                    <div className="itemBadge">
                      <h5 className="title">주문번호: </h5>
                      {data.order_id}
                    </div>
                    <div className="itemBadge">
                      <h5 className="title">접수번호(billNumber): </h5>
                      {data.bill_number}
                    </div>
                    {data.order_status === 4 && (
                      <>
                        <div className="itemBadge cancelText">
                          <h5 className="title">주문취소시간: </h5>
                          {moment(data.cancelled_at).format('yyyy.MM.DD HH:mm:ss')}
                        </div>
                        <div className="itemBadge cancelText">
                          <h5 className="title">주문취소사유: </h5>
                          {data.cancel_description}
                        </div>
                      </>
                    )}
                  </div>
                  <div className="row">
                    <div
                      className="itemBadge detailButton"
                      onClick={() => getOrderMenu(data.order_id, data.store_name)}>
                      메뉴상세보기
                    </div>
                    <div className="itemBadge">
                      <h5 className="title">결제금액: </h5>
                      {data.total_amount_incl.toLocaleString()}원
                    </div>
                    <div className="itemBadge">
                      <h5 className="title">주문금액: </h5>
                      {data.total_amount_org.toLocaleString()}원
                      <h5 className="title gap">IVID할인: </h5>
                      <h5 className="title">{data.com_discount_amount.toLocaleString()}원</h5>
                      <h5 className="title gap">매장할인: </h5>
                      <h5 className="title">{data.store_discount_amount.toLocaleString()}원</h5>
                    </div>
                    <div className="itemBadge">
                      <h5 className="title">배달팁: </h5>
                      {data.delivery_tip.toLocaleString()}원
                    </div>
                    <div className="itemBadge">
                      <h5 className="title">객실관리팁: </h5>
                      {data.room_tip.toLocaleString()}원
                    </div>
                    <div className="itemBadge">
                      <h5 className="title">발급사명: </h5>
                      {data.issuer_name}
                    </div>
                    <div className="itemBadge">
                      <h5 className="title">배달방법: </h5>
                      {data.delivery_type === 0 ? '배달연동' : '직접배달'}
                    </div>
                  </div>
                  <div className="row dotted">
                    <div className="itemBadge">
                      <h5 className="title">매장명: </h5>
                      {data.store_name}
                    </div>

                    <div className="itemBadge">
                      <h5 className="title">픽업장소: </h5>
                      {data.pickup_name}
                    </div>
                    <div className="itemBadge">
                      <h5 className="title">요청사항: </h5>
                      {data.inquiry === '' ? ' -' : data.inquiry}
                    </div>
                    <div className="itemBadge flag">
                      <h5 className="title">언어</h5>
                      {getStatusCountry(data.lang)}
                    </div>
                    <div
                      className="itemBadge logButton"
                      onClick={() => getOrderPath(data.order_id, data.store_name)}>
                      POS로그확인
                    </div>
                  </div>
                  <div className="row">
                    <div className="itemBadge info">
                      주문 확인:
                      {data.confirmed_at === null
                        ? '-'
                        : moment(data.confirmed_at).format('HH:mm:ss')}
                    </div>
                    <div className="itemBadge info">
                      주문 준비 완료:
                      {data.prepared_at === null
                        ? '-'
                        : moment(data.prepared_at).format('HH:mm:ss')}
                    </div>
                    <div className="itemBadge info">
                      배달도착 예상시간:
                      {data.delivery_expected_at === null
                        ? '-'
                        : moment(data.delivery_expected_at).format('HH:mm:ss')}
                    </div>
                    <div className="itemBadge info">
                      배달 시작:
                      {data.delivery_started_at === null
                        ? '-'
                        : moment(data.delivery_started_at).format('HH:mm:ss')}
                    </div>
                    <div className="itemBadge info">
                      배달 완료:
                      {data.delivery_completed_at === null
                        ? '-'
                        : moment(data.delivery_completed_at).format('HH:mm:ss')}
                    </div>
                    {data.order_status === 0 && (
                      <div>
                        <button onClick={() => managerReadyOrder(data)} className="readyOrderBtn">
                          주문접수 관리
                        </button>
                      </div>
                    )}
                    {data.order_status !== 7 && data.order_status !== 4 && (
                      <div>
                        <button
                          onClick={() => managerAuthorityButton(data, 'delivery')}
                          className="manualDeliveryBtn">
                          배달완료 관리
                        </button>
                      </div>
                    )}
                    {
                      data.order_status !== 4 && (
                        // currentTime.diff(moment(data.ordered_at), 'hours') <= 24 && (
                        <div>
                          <button
                            onClick={() => managerAuthorityButton(data, 'refund')}
                            className="refundBtn">
                            강제 취소
                          </button>
                        </div>
                      )
                      // )
                    }
                    {data.delivery_score && (
                      <div className="itemBadge info score">
                        배달기사 리뷰:{data.delivery_score}
                      </div>
                    )}
                    {data.food_score && (
                      <div className="itemBadge info score"> 음식 리뷰:{data.food_score}</div>
                    )}
                    {data.content && (
                      <div className="itemBadge info score"> 리뷰 상세 내용:{data.content}</div>
                    )}
                  </div>
                </div>
              ) : (
                <div className="historyItem log">
                  <div className="row">
                    <div className="itemBadge title">고객 로그</div>
                    <div className="itemBadge">
                      <h5 className="title">호텔명: </h5>
                      {data.hotel_name}
                    </div>
                    <div className="itemBadge">
                      <h5 className="title">객실: </h5>
                      {data.name}
                    </div>

                    <div className="itemBadge">
                      <h5 className="title">클릭: </h5>
                      {data.store_name} {getClickStatus(data.params)} - {data.params2}
                    </div>
                    <div className="itemBadge">
                      <h5 className="title">클릭 시각: </h5>
                      {moment(data.created_at).format('yyyy.MM.DD HH:mm:ss')}
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        })}
        <MenuDetailModal
          orderId={detailOrderId}
          storeName={storeName}
          orderDetail={orderDetail}
          isVisible={visibleOrder}
          setVisible={setVisibleOrder}
        />
        <ReadyAdminForceModal
          isVisible={visibleReadyOrder}
          setVisible={setVisibleReadyOrder}
          storeDetailData={storeDetailData}
          successOrder={successManagerReadyOrder}
        />
        <OrderLogModal
          isVisible={visibleOrderLog}
          setVisible={setVisibleOrderLog}
          pathLogData={orderLogData}
          orderId={detailOrderId}
          storeName={storeName}
        />
      </div>
    );
  };

  useEffect(() => {
    const totalData: TotalType = {
      totalOrderCount: 0,
      successOrderCount: 0,
      cancelOrderCount: 0,
      totalCancelAmountIncSum: 0,
      totalAmountIncSum: 0,
      totalAmountOrgSum: 0,
      companyDiscountSum: 0,
      storeDiscountSum: 0,
      deliveryTipSum: 0,
      roomTipSum: 0,
    };

    const hotelTotalRecord: Record<string, TotalType> = {};

    for (const sale of filteredItems) {
      if (sale.data_type === 'order') {
        totalData.totalOrderCount = totalData.totalOrderCount + 1;

        if (sale.order_status === 7 || sale.order_status === 5) {
          totalData.successOrderCount = totalData.successOrderCount + 1;
        }

        if (sale.order_status === 4) {
          totalData.cancelOrderCount = totalData.cancelOrderCount + 1;
          totalData.totalCancelAmountIncSum =
            totalData.totalCancelAmountIncSum + sale.total_amount_incl;
        } else {
          totalData.totalAmountIncSum = totalData.totalAmountIncSum + sale.total_amount_incl;
          totalData.totalAmountOrgSum = totalData.totalAmountOrgSum + sale.total_amount_org;
          totalData.companyDiscountSum = totalData.companyDiscountSum + sale.com_discount_amount;
          totalData.storeDiscountSum = totalData.storeDiscountSum + sale.store_discount_amount;
          totalData.deliveryTipSum = totalData.deliveryTipSum + sale.delivery_tip;
          totalData.roomTipSum = totalData.roomTipSum + sale.room_tip;
        }

        if (!hotelTotalRecord[sale.hotel_name]) {
          hotelTotalRecord[sale.hotel_name] = {
            totalOrderCount: 0,
            successOrderCount: 0,
            cancelOrderCount: 0,
            totalCancelAmountIncSum: 0,
            totalAmountIncSum: 0,
            totalAmountOrgSum: 0,
            companyDiscountSum: 0,
            storeDiscountSum: 0,
            deliveryTipSum: 0,
            roomTipSum: 0,
          };
        }

        hotelTotalRecord[sale.hotel_name].totalOrderCount =
          hotelTotalRecord[sale.hotel_name].totalOrderCount + 1;

        if (sale.order_status === 7 || sale.order_status === 5) {
          hotelTotalRecord[sale.hotel_name].successOrderCount =
            hotelTotalRecord[sale.hotel_name].successOrderCount + 1;
        }

        if (sale.order_status === 4) {
          hotelTotalRecord[sale.hotel_name].cancelOrderCount =
            hotelTotalRecord[sale.hotel_name].cancelOrderCount + 1;
          hotelTotalRecord[sale.hotel_name].totalCancelAmountIncSum =
            hotelTotalRecord[sale.hotel_name].totalCancelAmountIncSum + sale.total_amount_incl;
        } else {
          hotelTotalRecord[sale.hotel_name].totalAmountIncSum =
            hotelTotalRecord[sale.hotel_name].totalAmountIncSum + sale.total_amount_incl;
          hotelTotalRecord[sale.hotel_name].totalAmountOrgSum =
            hotelTotalRecord[sale.hotel_name].totalAmountOrgSum + sale.total_amount_org;
          hotelTotalRecord[sale.hotel_name].companyDiscountSum =
            hotelTotalRecord[sale.hotel_name].companyDiscountSum + sale.com_discount_amount;
          hotelTotalRecord[sale.hotel_name].storeDiscountSum =
            hotelTotalRecord[sale.hotel_name].storeDiscountSum + sale.store_discount_amount;
          hotelTotalRecord[sale.hotel_name].deliveryTipSum =
            hotelTotalRecord[sale.hotel_name].deliveryTipSum + sale.delivery_tip;
          hotelTotalRecord[sale.hotel_name].roomTipSum =
            hotelTotalRecord[sale.hotel_name].roomTipSum + sale.room_tip;
        }
      }
    }

    const hotelData: {
      hotel_name: string;
      total: TotalType;
    }[] = [];

    for (const key in hotelTotalRecord) {
      hotelData.push({
        hotel_name: key,
        total: hotelTotalRecord[key],
      });
    }

    hotelData.sort((a, b) => b.total.totalAmountIncSum - a.total.totalAmountIncSum);

    const StoreTotalRecord: Record<string, TotalType> = {};

    for (const sale of filteredItems) {
      if (sale.data_type === 'order') {
        if (!StoreTotalRecord[sale.store_name]) {
          StoreTotalRecord[sale.store_name] = {
            totalOrderCount: 0,
            successOrderCount: 0,
            cancelOrderCount: 0,
            totalCancelAmountIncSum: 0,
            totalAmountIncSum: 0,
            totalAmountOrgSum: 0,
            companyDiscountSum: 0,
            storeDiscountSum: 0,
            deliveryTipSum: 0,
            roomTipSum: 0,
          };
        }

        StoreTotalRecord[sale.store_name].totalOrderCount =
          StoreTotalRecord[sale.store_name].totalOrderCount + 1;

        if (sale.order_status === 7 || sale.order_status === 5) {
          StoreTotalRecord[sale.store_name].successOrderCount =
            StoreTotalRecord[sale.store_name].successOrderCount + 1;
        }

        if (sale.order_status === 4) {
          StoreTotalRecord[sale.store_name].cancelOrderCount =
            StoreTotalRecord[sale.store_name].cancelOrderCount + 1;
          StoreTotalRecord[sale.store_name].totalCancelAmountIncSum =
            StoreTotalRecord[sale.store_name].totalCancelAmountIncSum + sale.total_amount_incl;
        } else {
          StoreTotalRecord[sale.store_name].totalAmountIncSum =
            StoreTotalRecord[sale.store_name].totalAmountIncSum + sale.total_amount_incl;
          StoreTotalRecord[sale.store_name].totalAmountOrgSum =
            StoreTotalRecord[sale.store_name].totalAmountOrgSum + sale.total_amount_org;
          StoreTotalRecord[sale.store_name].companyDiscountSum =
            StoreTotalRecord[sale.store_name].companyDiscountSum + sale.com_discount_amount;
          StoreTotalRecord[sale.store_name].storeDiscountSum =
            StoreTotalRecord[sale.store_name].storeDiscountSum + sale.store_discount_amount;
          StoreTotalRecord[sale.store_name].deliveryTipSum =
            StoreTotalRecord[sale.store_name].deliveryTipSum + sale.delivery_tip;
          StoreTotalRecord[sale.store_name].roomTipSum =
            StoreTotalRecord[sale.store_name].roomTipSum + sale.room_tip;
        }
      }
    }

    const storeData: {
      hotel_name: string;
      total: TotalType;
    }[] = [];

    for (const key in StoreTotalRecord) {
      storeData.push({
        hotel_name: key,
        total: StoreTotalRecord[key],
      });
    }

    storeData.sort((a, b) => b.total.totalAmountIncSum - a.total.totalAmountIncSum);

    setStoreTotal(storeData);
    setHotelTotal(hotelData);
    setTotal(totalData);
  }, [filteredItems]);

  
  useEffect(() => {
    const filteredItemsData = searchStoreName
      ? salesList.filter((item: SalesListType) =>
          (item.store_name?.toLowerCase() || "").includes(searchStoreName.toLowerCase())
        )
      : salesList;
  
    setFilteredItems(filteredItemsData);
  }, [salesList, searchStoreName]);
  
  useEffect(() => {
    getSettlement();
  }, [startDate, endDate]);

  // const totalOrderCount = filteredItems.filter(
  //   (order: SalesListType) => order.data_type === 'order',
  // ).length;
  // const successOrderCount = filteredItems.filter(
  //   (order: SalesListType) => order.order_status === 7 && order.data_type === 'order',
  // ).length;
  // const cancelOrderCount = filteredItems.filter(
  //   (order: SalesListType) => order.order_status === 4 && order.data_type === 'order',
  // ).length;
  // const totalCancelAmountIncSum = filteredItems
  //   .filter((order: SalesListType) => order.order_status === 4 && order.data_type === 'order')
  //   .reduce((sum: any, order: SalesListType) => sum + order.total_amount_incl, 0); // 주문 취소 총 결제금액
  // const totalAmountIncSum = filteredItems
  //   .filter((order: SalesListType) => order.order_status !== 4 && order.data_type === 'order')
  //   .reduce((sum: any, order: SalesListType) => sum + order.total_amount_incl, 0); // 총 결제금액
  // const totalAmountOrgSum = filteredItems
  //   .filter((order: SalesListType) => order.order_status !== 4 && order.data_type === 'order')
  //   .reduce((sum: any, order: SalesListType) => sum + order.total_amount_org, 0); // 총 주문금액
  // const companyDiscountSum = filteredItems
  //   .filter((order: SalesListType) => order.order_status !== 4 && order.data_type === 'order')
  //   .reduce((sum: any, order: SalesListType) => sum + order.com_discount_amount, 0); // ivid 할인금액
  // const storeDiscountSum = filteredItems
  //   .filter((order: SalesListType) => order.order_status !== 4 && order.data_type === 'order')
  //   .reduce((sum: any, order: SalesListType) => sum + order.store_discount_amount, 0); // 매장,호텔 할인금액
  // const deliveryTipSum = filteredItems
  //   .filter((order: SalesListType) => order.order_status !== 4 && order.data_type === 'order')
  //   .reduce((sum: any, order: SalesListType) => sum + order.delivery_tip, 0); // 배달팁
  // const roomTipSum = filteredItems
  //   .filter((order: SalesListType) => order.order_status !== 4 && order.data_type === 'order')
  //   .reduce((sum: any, order: SalesListType) => sum + order.room_tip, 0); // 배달팁

  return (
    <Style>
      <div className="wrap">
        <button className="backButton" onClick={() => navigate('/dashboard')}>
          <img src={`${process.env.PUBLIC_URL}/svg/ic_home.svg`} alt="뒤로가기버튼" />
        </button>
        <h1>KNOCKKNOCK 판매현황</h1>
        <h2>파트너스</h2>
        <div className="statusWrap">
          <div className="statusBox">
            <h5>호텔</h5>
            <h4>15</h4>
          </div>
          <div className="statusBox">
            <h5>매장</h5>
            <h4>-</h4>
          </div>
        </div>
        <h2>총 주문건수</h2>
        <div className="statusWrap">
          <div className="statusBox">
            <h5>주문완료</h5>
            <h4>{filteredItems && total.totalOrderCount}건</h4>
          </div>
          <div className="statusBox">
            <h5>배달완료</h5>
            <h4>{filteredItems && total.successOrderCount}건</h4>
          </div>
          <div className="statusBox">
            <h5>취소</h5>
            <h4>{filteredItems && total.cancelOrderCount}건</h4>
          </div>
        </div>
        <div className="tabWrap">
          <div className="tabContainer">
            <div className="tabContent">
              {dateTabContent.map((section, index) => (
                <button
                  key={'dateButtons-' + index.toString()}
                  onClick={() => tabClick(index)}
                  className={dateContentItem.id === section.id ? 'tab active' : 'tab'}>
                  <h2>{section.tab}</h2>
                </button>
              ))}
            </div>
            {dateContentItem.id === 4 && (
              <div className="calendarWrap">
                <label htmlFor="startDatePicker" className="calendarContainer">
                  <ReactDatePicker
                    id={'startDatePicker'}
                    className="datePicker"
                    selectsRange={true}
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(update) => handleDateChange(update)}
                    dateFormat="yyyy-MM-dd"
                    isClearable={false}
                    locale={ko}
                    disabledKeyboardNavigation={true}
                    onFocus={(e) => {
                      e.preventDefault();
                      e.target.blur();
                    }}
                  />
                </label>
              </div>
            )}
          </div>
        </div>
        <h2>총 결제 금액</h2>
        <div className="statusWrap">
          <div className="statusBox">
            <h5>결제금액 (할인 포함)</h5>
            <h4>{total.totalAmountIncSum.toLocaleString()}원</h4>
          </div>
          <div className="statusBox">
            <h5>주문금액</h5>
            <h4>{total.totalAmountOrgSum.toLocaleString()}원</h4>
          </div>
          <div className="statusBox">
            <h5>총 할인금액</h5>
            <h4>{(total.companyDiscountSum + total.storeDiscountSum).toLocaleString()}원</h4>
          </div>
          <div className="statusBox">
            <h5>IVID 부담</h5>
            <h4>{total.companyDiscountSum.toLocaleString()}원</h4>
          </div>
          <div className="statusBox">
            <h5>매장/호텔 부담</h5>
            <h4>{total.storeDiscountSum.toLocaleString()}원</h4>
          </div>
          <div className="statusBox">
            <h5>배달팁</h5>
            <h4>{total.deliveryTipSum.toLocaleString()}원</h4>
          </div>
          <div className="statusBox">
            <h5>객실관리팁</h5>
            <h4>{total.roomTipSum.toLocaleString()}원</h4>
          </div>
          <div className="statusBox">
            <h5>취소금액</h5>
            <h4>{total.totalCancelAmountIncSum.toLocaleString()}원</h4>
          </div>
        </div>

        <div className="sortButtonWrap">
          <button
            className={`sortHotel ${hotelVisible && 'active'}`}
            onClick={() => {
              setHotelVisible(!hotelVisible);
            }}>
            {hotelVisible ? '호텔 통계 숨기기' : '호텔 통계 보기'}
          </button>
          <button
            className={`sortStore ${storeVisible && 'active'}`}
            onClick={() => {
              setStoreVisible(!storeVisible);
            }}>
            {storeVisible ? '매장 통계 숨기기' : '매장 통계 보기'}
          </button>
          <button
            className={`sortCartLog ${pathLogVisible && 'active'}`}
            onClick={() => {
              setPathLogVisible(!pathLogVisible);
            }}>
            {pathLogVisible ? '장바구니 로그 숨기기' : '장바구니 로그 보기(당일만 가능)'}
          </button>
        </div>
        {hotelVisible && (
          <>
            {hotelTotal.length > 0 ? (
              <CustomTable
                tableHeader={excelHotelHeader}
                // subHeader={excelSubHeader}
                renderTableItem={renderHotelTableItem}
                type="border"
              />
            ) : (
              <div className="noneData">
                <p>호텔 통계가 없습니다.</p>
              </div>
            )}
          </>
        )}
        {storeVisible && (
          <>
            {storeTotal.length > 0 ? (
              <CustomTable
                tableHeader={excelStoreHeader}
                // subHeader={excelSubHeader}
                renderTableItem={renderStoreTableItem}
                type="border"
              />
            ) : (
              <div className="noneData">
                <p>매장 통계가 없습니다.</p>
              </div>
            )}
          </>
        )}
        {/* <h2>광고</h2>
        <div className="statusWrap">
          <div className="statusBox" style={{ background: '#aaa' }}>
            <h5>연결 매장</h5>
            <h4>-</h4>
          </div>
          <div className="statusBox" style={{ background: '#aaa' }}>
            <h5>연결 호텔</h5>
            <h4>-</h4>
          </div>
          <div className="statusBox" style={{ background: '#aaa' }}>
            <h5>광고 수익</h5>
            <h4>-</h4>
          </div>
        </div> */}
        <div className="searchWrap">
          <input
            type="text"
            placeholder="매장명을 검색해주세요"
            value={searchStoreName}
            onChange={handleSearchStoreName}
          />
          <button className="searchButton">검색</button>
        </div>
        <RenderHistoryList />
      </div>
    </Style>
  );
};

export default KnockSales;

const Style = styled.div`
  .wrap {
    width: 100%;
    padding: 30px 3vw;
    background: #ffffff;
  }
  h1 {
    font-size: 24px;
    margin-bottom: 30px;
  }

  h2 {
    font-size: 20px;
    color: #333333;
    font-weight: 600;
    padding-bottom: 6px;
  }

  /* tabWrap */
  .tabWrap {
    width: 100%;
    margin-top: 30px;
  }
  .tabContainer {
    display: flex;
    width: 100%;
  }
  .tabContent {
    /* width: 40%; */
    margin-bottom: 12px;
    border: 1px solid #cecece;
    border-radius: 6px;

    button {
      /* width: 20%; */
      flex: 1;
      padding: 12px 25px;
      background: none;
      border: none;
      border-right: 1px solid #cecece;

      h2 {
        padding: 0;
        font-size: 18px;
      }
    }
    button:nth-child(5) {
      border-right: none;
    }
  }
  .tab.active {
    background: #000;

    h2 {
      color: #fff;
    }
  }
  .tab:nth-child(1).active {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
  }
  .tab:nth-child(5).active {
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
  }

  /* calendarWrap */
  .datePicker {
    margin-left: 10px;
    padding: 13px;
    border-radius: 6px;
    text-align: center;
    border: 1px solid #000;
  }

  /* sortButtonWrap */
  .sortButtonWrap {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;

    button {
      padding: 5px 16px;
      font-size: 16px;
      border-radius: 5px;
      border: 1px solid #cecece;
    }
    .sortHotel.active {
      background: #000;
      color: #fff;
    }
    .sortStore.active {
      background: #000;
      color: #fff;
    }
    .sortCartLog.active {
      background: #000;
      color: #fff;
    }
  }
  .noneData {
    margin-top: 10px;
    border-radius: 5px;
    border: 1px solid #cecece;
    background: #fcfcfc;
    p {
      font-size: 14px;
      text-align: center;
    }
  }
  /* 매장검색 */
  .searchWrap {
    display: flex;
    align-items: center;
    margin: 10px 0;

    input {
      width: auto;
      min-width: 30%;
      padding: 10px;
      border: none;
      border-bottom: 1px solid #cecece;
      outline: none;
      font-size: 20px;
    }
    .searchButton {
      padding: 12px 40px;
      border-radius: 4px;
      border: none;
      background: #333333;
      font-size: 18px;
      font-weight: 500;
      color: #ffffff;
    }
  }

  /* historyList */
  .historyList {
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    gap: 4px;

    .historyItem {
      display: flex;
      flex-direction: column;
      gap: 4px;
      border-radius: 5px;
      background: #fcfcfc;
      border: 1px solid #cecece;
      padding: 6px;

      .row {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 4px;
      }
      .row.dotted {
        padding-bottom: 3px;
        border-bottom: 1px dotted #cecece;
      }
      .itemBadge {
        display: flex;
        padding: 6px 8px;
        align-items: center;
        font-size: 14px;
        line-height: 16px;
        font-weight: 400;
        color: #333333;
        border-radius: 3px;
        background: #ffffff;
        border: 1px solid #cecece;
        white-space: nowrap;

        h5.title {
          font-size: 14px;
          line-height: 16px;
          font-weight: 400;
          padding: 0 4px 0 0;
          color: #aaaaaa;
        }
        h5.gap {
          padding-left: 8px;
        }
      }
      .itemBadge.status {
        background: #4dd2ae;
        border: 1px solid #4dd2ae;
        color: #ffffff;
      }
      .itemBadge.cancel {
        background: red;
        border: 1px solid red;
      }
      .itemBadge.cancelText {
        color: red;
      }
      .itemBadge.info {
        padding: 3px 6px;
        border: 1px solid #d9d9d9;
        background: #d9d9d9;
      }
      .itemBadge.info.score {
        background: #eee;
      }
      .itemBadge.detailButton {
        padding: 6px 12px;
        background: linear-gradient(180deg, #648fe7 3.06%, #0d2a6c 97.5%);
        border-radius: 4px;
        box-shadow: 4px 4px 4px 0px #0000001a;
        border: 3px solid linear-gradient(281.11deg, #132756 1.98%, #ccddff 97.75%);
        color: #fff;
        font-weight: 600;
        cursor: pointer;
      }
      .itemBadge.logButton {
        padding: 6px 12px;
        background: linear-gradient(180deg, #4ff2ac 3.06%, #4dd2ae 97.5%);
        border-radius: 4px;
        box-shadow: 4px 4px 4px 0px #0000001a;
        border: 3px solid linear-gradient(281.11deg, #132756 1.98%, #ccddff 97.75%);
        color: #fff;
        font-weight: 600;
        cursor: pointer;
      }
    }
    .historyItem.log {
      background: rgba(0, 0, 0, 0.05);
      padding: 4px 8px;

      .itemBadge {
        padding: 4px 6px;
        background: #fff;
        font-size: 14px;
      }
      .itemBadge.title {
        background: yellow;
        color: #000;
      }
    }
  }
  .statusWrap {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
    padding-bottom: 20px;

    .statusBox {
      width: 150px;
      border-radius: 5px;
      border: 1px solid #cecece;
      background: #fcfcfc;
      padding: 4px 20px;

      h5 {
        font-weight: 400;
      }
      h4 {
        padding-top: 6px;
        font-weight: 700;
      }
    }
  }
  .flag img {
    width: 23px;
  }

  .manualDeliveryBtn,
  .readyOrderBtn,
  .refundBtn {
    background: #000;
    border: none;
    color: #fff;
    padding: 4px 8px;
    font-size: 14px;
    font-weight: 500;
    border-radius: 4px;
  }
  .readyOrderBtn {
    background: #4ddeae;
  }
  .refundBtn {
    background: red;
  }
`;
